import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
  desktopSmall?: boolean;
  small?: boolean;
}

export const ErrorBox: FC<Props> = (props) => (
  <span
    className={classNames(
      'header__error-box',
      props.small && 'block',
      props.desktopSmall && 'header__error-box--desktop-small',
      props.className,
    )}
  >
    {props.children}
  </span>
);
